// src/components/Disclaimer.js
import React from 'react';

const Disclaimer = () => {
  return (
    <footer className="bg-red-600 text-white p-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-4">
          <h2 className="text-xl font-bold mb-2">502 Gold - Your Trusted Matka Platform</h2>
          <p className="text-sm mb-2">
            Purchase of lottery using this website is strictly prohibited in states where lotteries are banned.
            You must be above 18 years to play online lottery.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-4 mb-4 text-sm">
          <div>
            <h3 className="font-bold mb-2">Quick Links</h3>
            <ul>
              <li><a href="/" className="hover:underline">Home</a></li>
              <li><a href="/results" className="hover:underline">Live Results</a></li>
              <li><a href="/about" className="hover:underline">About 502 Gold</a></li>
              <li><a href="/contact" className="hover:underline">Contact Us</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold mb-2">Popular Games</h3>
            <ul>
              <li>Matka Results</li>
              <li>Satta King</li>
              <li>Live Draw</li>
              <li>Daily Updates</li>
            </ul>
          </div>
        </div>
        
        <div className="text-center text-sm border-t border-red-400 pt-4">
          <p>
            ©2024 502 Gold - All Rights Reserved | 
            <a href="https://www.502gold.com" className="hover:underline ml-1">
              Official Website: www.502gold.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Disclaimer;
